import { Component, effect, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SettingsService } from './features/settings/settings.service';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  private readonly title = inject(Title);
  private readonly settingsService = inject(SettingsService);

  constructor() {
    effect(() => {
      const companyName = this.settingsService.companyName().trim();
      this.title.setTitle(companyName ? `${companyName} — Gestion de stock` : 'Gestion de stock');
    });
  }
}
